import React from "react";


export default function CashSaleRow({data}){

    const getSource = () => {
        if(data.job){
            return "JOB "+data.job
        }
        else if(data.movement){
            return "MOVEMENT "+data.movement
        }
        else if(data.rental){
             return "RENTAL "+data.rental
        }
        else if(data.transaction){
            return "INCOME "+data.transaction
        }
        else if(data.part_order){
            return "PART ORDER "+data.part_order
        }
    };


    return (
        <tr>
            <td>{data.name}</td>
            <td>{data.email}</td>
            <td>{data.phone}</td>
            <td>{data.address}</td>
            <td>£{data.amount}</td>
            <td>{getSource()}</td>
        </tr>
    )

}